import React from 'react';
import PropTypes from 'prop-types';

import Slider from './components/Slider/Slider.jsx';
import StatesDescription from './components/StatesDescription/StatesDescription.jsx';

const EstimateSlider = ({ tradeInValues, handleRangeChange, handleEstimateChange }) => {
    return (
        <div className="slider__content">
            <Slider
                tradeInValues={tradeInValues}
                handleRangeChange={handleRangeChange}
                handleEstimateChange={handleEstimateChange}
            />
            <StatesDescription />
        </div>
    );
};

EstimateSlider.propTypes = {
    tradeInValues: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        high: PropTypes.number.isRequired,
        low: PropTypes.number.isRequired,
        taxesFactor: PropTypes.number.isRequired,
    }).isRequired,
    handleRangeChange: PropTypes.func.isRequired,
    handleEstimateChange: PropTypes.func.isRequired,
};

export default EstimateSlider;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/EstimateSlider.jsx